import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { APP_ENVIRONMENT, DSN_SENTRY, FS_ORGID } from './config';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import { init } from '@fullstory/browser';
import './index.css';

const container = document.getElementById('root');
const root = createRoot(container);

if (window.location.hostname !== 'localhost') {
  Sentry.init({
    dsn: DSN_SENTRY,
    integrations: [new BrowserTracing()],
    release: '1.0.0',
    environment: APP_ENVIRONMENT || 'development',
    beforeSend(event, hint) {
      const error = hint.originalException;
      if (error && error.name === 'AxiosError') {
        return null;
      }
      return event;
    },
  });
}

init({ orgId: FS_ORGID });

root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
